import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  public isOnline!: boolean;
  constructor() { }

  get_filter() {
    return 'فیلتر';
  }
  get_new() {
    return 'جدید';
  }
  get_search() {
    return 'کلمه کلیدی مدنظرتان را تایپ کنید...';
  }
  get_all() {
    return 'همه';
  }
  get_no_record_text() {
    return 'هیچ رکوردی برای نمایش وجود ندارد';
  }
  get_event_title(type_task: any) {
    if (type_task == 1) {
      return 'ذخیره';
    }
    if (type_task == 2) {
      return 'ویرایش';
    }
    if (type_task == 3) {
      return 'جستجو';
    }
  }
  get_title(type_task: any) {
    if (type_task == 1) {
      return 'جدید';
    }
    if (type_task == 2) {
      return 'ویرایش';
    }
    if (type_task == 3) {
      return 'فیلتر';
    }
  }
  get_today(lang) {
    if (lang == 1) { return 'امروز'; }
    if (lang == 2) { return 'Today'; }
  }
  send_message() {
    return "پیامک با موفقیت ارسال شد";
  }
  erorr_in_load() {
    return "خطا در دریافت";
  }
  erorr_in_save() {
    return "خطا در ذخیره"
  }
  erorr_in_send(lang: number) {
    if (lang == 1) {
      return "خطا در ارسال"
    } else {
      return "An error occurred while sending";
    }
  }
  message(message) {
    return message;
  }
  internet() {
    return "خطا در اینترنت";
  }
  erorr_in_save_default(lang: number) {
    if (lang == 1) {
      return "شما می توانید فقط یک گزینه را پیش فرض کنید"
    } else {
      return "You can only set one option as default";
    }
  }
  save() {
    return "با موفقیت ذخیره شد";
  }
  change() {
    return "با موفقیت تغییر یافت"
  }
  //******************************************************************************** */
  repeat() {
    return "عنوان باید منحصر به فرد باشد";
  }
  repeat2() {
    return "هر عنوان در هر دسته و گروه باید منحصر به فرد باشد";
  }
  repeat3(lang: number) {
    return "این رکورد قبلا اضافه شده است";
  }
  //******************************************************************************** */
  access() {
    return "خطا در دسترسی";
  }

  access2() {
    return "شما دسترسی به این سرویس را ندارید";
  }
  //******************************************************************************** */
  close() {
    return "بستن";
  }

  add(lang: number) {
    if (lang == 1) {
      return "اضافه شد.";
    } else {
      return "Added.";
    }
  }
  expire() {
    return "اکانت شما منقضی شده است . لطفا تمدید نمائید";
  }

  //******************************************************************************** */
  delete(): string {
    return "با موفقیت حذف شد";;
  }
  delete2() {
    return "حذف شد";
  }
  message_action(lang: number): string {
    if (lang == 1) {
      return 'بستن';
    } else {
      return 'close';
    }
  }
  message_delete(): string {
    return "با موفقیت حذف شد";
  }
  message_delete_alarm() {
    return "این رکورد در ماژول هایی در حال استفاده می باشد و قادر به حذف نخواهید بود";

  }
  message_error(): string {
    return "دریافت خطا";
  }
  message_delete_erorr() {
    return "خطا در حذف";
  }
  message_delete_accept() {
    return "آیا از حذف اطمینان دارید؟";
  }
  //********************************wharehouse************************************************ */
  wharehouse_inventory1(lang: number) {
    if (lang == 1) {
      return "تعدادی درج شده بیشتر ار خروجی انبار می باشد .لطفا اصلاح نمائید";
    } else { return "The selected quantity exceeds the available stock in the warehouse. Please choose a lower quantity"; }
  }

  wharehouse_alarm_cate(lang: number) {
    if (lang == 1) {
      return "برای درج زیرگروه نیاز است تا گروه انتخاب شده باشد";
    } else { return "In order to add a subgroup, you need to select a group first"; }
  }
  //********************************sms************************************************ */
  error_format_cellphone(lang: number) {
    if (lang == 1) {
      return "فرمت شماره برای ارسال پیامک معتبر نمی باشد";
    } else { return "The phone number format is not valid for sending text messages"; }
  }

  error_sharj_sms(lang: number) {
    if (lang == 1) {
      return "قادر به ارسال پیامک نمی باشید لطفا شارژ نمائید";
    } else { return "You are unable to send text messages. Please recharge your account"; }
  }
  error_sharj_sms_with_save(lang: number) {
    if (lang == 1) {
      return "فاکتور یا موفقیت ثبت شد ولی قادر به ارسال پیامک نمی باشید لطفا شارژ نمائید";
    } else { return "The invoice was successfully recorded, but you are unable to send text messages. Please recharge your account"; }
  }
  message_sms_accept() {
    return "آیا از ارسال اطمینان دارید؟";
  }
  check_internet() {
    this.isOnline = navigator.onLine;
    if (this.isOnline == false) {
      return false;
    }
    else {
      return true;
    }//end else
  }//end check_internet
  get_title_reception(type_task) {
    if (type_task == 1) {
      return 'قبض پذیرش جدید';
    }
    if (type_task == 2) {
      return 'ویرایش قبض';
    }
    if (type_task == 3) {
      return 'فیلتر';
    }
  }
  get_title_reception1(type_task: number, number: number) {
    if (type_task == 1) {
      return 'قبض پذیرش جدید';
    }
    if (type_task == 2) {
      return ' ویرایش قبض شماره ' + number;
    }
    if (type_task == 3) {
      return 'فیلتر';
    }
  }
}
